import * as React from 'react';
import * as styles from './styles.scss';
import { observer } from 'mobx-react-lite';
import { today, formatShortWeekDay, formatWeekDay, addDays } from 'owa-datetime';
import type { MultidayForecast, WeatherInfo } from '../schema';
import {
    weatherAssetDegrees,
    weatherAssetForecastTitle,
    weatherAssetForecastAriaLabel,
} from '../weather.locstring.json';
import loc from 'owa-localize';

export default observer(function WeatherMultidayView({ forecast }: MultidayForecast) {
    const todayDate = today();
    return (
        <div className={styles.multidayForecastContainer}>
            {forecast.map((weatherInfo: WeatherInfo, index: number) => {
                const rawDay = addDays(todayDate, index);

                // day is abbreviated (e.g. MON), fullDay is not (e.g. Monday)
                const day = formatShortWeekDay(rawDay).toUpperCase();
                const fullDay = formatWeekDay(rawDay);

                const weatherDetailsTitle = loc(
                    weatherAssetForecastTitle,
                    fullDay,
                    weatherInfo.high,
                    weatherInfo.low,
                    weatherInfo.skyText
                );

                const weatherDetailsAriaLabel = loc(
                    weatherAssetForecastAriaLabel,
                    fullDay,
                    weatherInfo.high,
                    weatherInfo.low,
                    weatherInfo.skyText
                );

                return (
                    <div
                        role="complementary"
                        aria-label={weatherDetailsAriaLabel}
                        key={day}
                        className={styles.multidayForecastInfo}
                        title={weatherDetailsTitle}>
                        <div aria-hidden={true}>{day}</div>
                        <div className={styles.multidayForecastTemp} aria-hidden={true}>
                            {loc(weatherAssetDegrees, weatherInfo.temp)}
                        </div>
                    </div>
                );
            })}
        </div>
    );
});
